// Seed port graph — the lane search's floor, never its ceiling.
//
// The typeahead normally builds its port list from the live lane feed. When that feed is slow
// or unreachable the fields used to sit on "Loading ports…" forever, with no suggestions and no
// way to type a lane by hand: one failed query took the whole product down (customer report,
// 2026-08-17). These are the busiest ex-Asia origins and the destinations they sail to, so a
// visitor can always pick a pair and reach a lane page or a quote.
//
// Not a rate source and not a coverage claim. Live lane ports win by code, but the seed is ALWAYS
// merged in so a port with no published lane yet (Chittagong, Abu Dhabi, Jebel Ali) can still be
// found, on either side of the search, and routes to a live engine quote instead of a dead field.

export interface SeedPort {
  code: string
  name: string
  country: string
}

export const SEED_ORIGINS: SeedPort[] = [
  { code: 'CNSHA', name: 'Shanghai', country: 'China' },
  { code: 'CNNGB', name: 'Ningbo', country: 'China' },
  { code: 'CNSZX', name: 'Shenzhen', country: 'China' },
  { code: 'CNYTN', name: 'Yantian', country: 'China' },
  { code: 'CNTAO', name: 'Qingdao', country: 'China' },
  { code: 'CNTXG', name: 'Tianjin', country: 'China' },
  { code: 'CNXMN', name: 'Xiamen', country: 'China' },
  { code: 'CNCAN', name: 'Guangzhou', country: 'China' },
  { code: 'CNDLC', name: 'Dalian', country: 'China' },
  { code: 'HKHKG', name: 'Hong Kong', country: 'Hong Kong' },
  { code: 'SGSIN', name: 'Singapore', country: 'Singapore' },
  { code: 'KRPUS', name: 'Busan', country: 'South Korea' },
  { code: 'JPTYO', name: 'Tokyo', country: 'Japan' },
  { code: 'JPYOK', name: 'Yokohama', country: 'Japan' },
  { code: 'TWKHH', name: 'Kaohsiung', country: 'Taiwan' },
  { code: 'VNSGN', name: 'Ho Chi Minh City', country: 'Vietnam' },
  { code: 'VNHPH', name: 'Haiphong', country: 'Vietnam' },
  { code: 'THLCH', name: 'Laem Chabang', country: 'Thailand' },
  { code: 'MYPKG', name: 'Port Klang', country: 'Malaysia' },
  { code: 'MYTPP', name: 'Tanjung Pelepas', country: 'Malaysia' },
  { code: 'IDJKT', name: 'Jakarta', country: 'Indonesia' },
  { code: 'INNSA', name: 'Nhava Sheva', country: 'India' },
  { code: 'INMAA', name: 'Chennai', country: 'India' },
  { code: 'INMUN', name: 'Mundra', country: 'India' },
  { code: 'BDCGP', name: 'Chittagong', country: 'Bangladesh' },
  { code: 'AEJEA', name: 'Jebel Ali', country: 'United Arab Emirates' },
  { code: 'AEAUH', name: 'Abu Dhabi', country: 'United Arab Emirates' },
]

export const SEED_DESTINATIONS: SeedPort[] = [
  { code: 'NLRTM', name: 'Rotterdam', country: 'Netherlands' },
  { code: 'DEHAM', name: 'Hamburg', country: 'Germany' },
  { code: 'BEANR', name: 'Antwerp', country: 'Belgium' },
  { code: 'GBFXT', name: 'Felixstowe', country: 'United Kingdom' },
  { code: 'GBLGP', name: 'London Gateway', country: 'United Kingdom' },
  { code: 'FRLEH', name: 'Le Havre', country: 'France' },
  { code: 'ESVLC', name: 'Valencia', country: 'Spain' },
  { code: 'ESBCN', name: 'Barcelona', country: 'Spain' },
  { code: 'ITGOA', name: 'Genoa', country: 'Italy' },
  { code: 'ITSPE', name: 'La Spezia', country: 'Italy' },
  { code: 'GRPIR', name: 'Piraeus', country: 'Greece' },
  { code: 'TRAMB', name: 'Ambarli', country: 'Turkey' },
  { code: 'PLGDN', name: 'Gdansk', country: 'Poland' },
  { code: 'SEGOT', name: 'Gothenburg', country: 'Sweden' },
  { code: 'USLAX', name: 'Los Angeles', country: 'United States' },
  { code: 'USLGB', name: 'Long Beach', country: 'United States' },
  { code: 'USNYC', name: 'New York', country: 'United States' },
  { code: 'USSAV', name: 'Savannah', country: 'United States' },
  { code: 'USHOU', name: 'Houston', country: 'United States' },
  { code: 'USSEA', name: 'Seattle', country: 'United States' },
  { code: 'USORF', name: 'Norfolk', country: 'United States' },
  { code: 'CAVAN', name: 'Vancouver', country: 'Canada' },
  { code: 'MXZLO', name: 'Manzanillo', country: 'Mexico' },
  { code: 'BRSSZ', name: 'Santos', country: 'Brazil' },
  { code: 'CLSAI', name: 'San Antonio', country: 'Chile' },
  { code: 'ZADUR', name: 'Durban', country: 'South Africa' },
  { code: 'AUSYD', name: 'Sydney', country: 'Australia' },
  { code: 'AUMEL', name: 'Melbourne', country: 'Australia' },
  { code: 'NZAKL', name: 'Auckland', country: 'New Zealand' },
  { code: 'AEJEA', name: 'Jebel Ali', country: 'United Arab Emirates' },
  { code: 'AEAUH', name: 'Abu Dhabi', country: 'United Arab Emirates' },
  { code: 'BDCGP', name: 'Chittagong', country: 'Bangladesh' },
  { code: 'SAJED', name: 'Jeddah', country: 'Saudi Arabia' },
  { code: 'EGALY', name: 'Alexandria', country: 'Egypt' },
  { code: 'SGSIN', name: 'Singapore', country: 'Singapore' },
  { code: 'JPTYO', name: 'Tokyo', country: 'Japan' },
  { code: 'KRPUS', name: 'Busan', country: 'South Korea' },
]
